import { render, staticRenderFns } from "./DatasetView.vue?vue&type=template&id=f5eaf750&scoped=true"
import script from "./DatasetView.vue?vue&type=script&lang=js"
export * from "./DatasetView.vue?vue&type=script&lang=js"
import style0 from "./DatasetView.vue?vue&type=style&index=0&id=f5eaf750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5eaf750",
  null
  
)

export default component.exports